import React, { useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@material-ui/core';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import QrReader from 'react-web-qr-reader';
import PropTypes from 'prop-types';
import CustomToast from '../Toast';
import { FACING_MODE_ENVIRONMENT, FACING_MODE_USER } from '../../Constants';
import './styles.css';

function index({ validateQRCode }) {
  const [facingMode, setFacingMode] = useState(FACING_MODE_ENVIRONMENT);
  const [scanning, setScanning] = useState(false);

  const handleScan = async (result) => {
    if (result && result.data !== '' && !scanning) {
      setScanning(true);
      validateQRCode(result);

      await delay(4000);

      setScanning(false);
    }
  };

  const delay = (duration) => {
    return new Promise((resolve) => setTimeout(resolve, duration));
  };

  const handleClick = () => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  };

  const handleError = (error) => {
    toast(<CustomToast severity="warning" message={error.message} />, {
      closeButton: false,
    });
  };

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <FlipCameraIosIcon
          variant="text"
          fontSize="large"
          onClick={handleClick}
          sx={{ color: 'white', background: 'transparent' }}
          className="camera-position"
        />
      </Box>
      <div>
        <QrReader
          className="qr-image-wrapper"
          onScan={handleScan}
          onError={handleError}
          facingMode={facingMode}
        />
      </div>
    </>
  );
}

index.propTypes = {
  validateQRCode: PropTypes.func.isRequired,
};

export default index;
